<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add">新增</Button>
		</div>
		
		<div class="query">
			<div class="checkbox">
				<div class="jms tj">
					<div>加盟商：</div>
					<Select v-model="query.alliances" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo1">
							<Option v-for="item in alliances" :value="item.id" :key="item.value">{{ item.companyName }}</Option>
					</Select>
				</div>
				<div class="time tj">
					<div>时间：</div>
					<div class="time-xz">
						<DatePicker type="datetime" placeholder="开始时间" v-model='kaishi' style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"  ></DatePicker>
						<div>--</div>
						<DatePicker type="datetime" placeholder="结束时间" v-model='jieshu' style="width: 200px" @on-change="onchangeJieshu" @on-ok="onok"  ></DatePicker>
					</div>
				</div>
			</div>
			 <Input class="sousuo" search enter-button placeholder="合同编号/责任人/录入人" v-model="query.like" style="width: 500px;" @on-search="onsearch"  /> 
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)" v-show="row.macContractState=='LRZ' || row.macContractState=='QRZ'">修改</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="details(row.id)">设备信息</Button>
				<Button @click="forbidden(row.id)" size="small" style="margin-right: 5px" class="delete" v-show="row.macContractState=='LRZ'">录入完成</Button>
				<Modal v-model="modal2" width="360">
					<p slot="header" style="color:#f60;text-align:center">
						<Icon type="ios-information-circle"></Icon>
						<span>修改状态</span>
					</p>
					<div style="text-align:center">
						<p>状态修改为录入完成之后，需要加盟商在线确认合同信息，确认录入完成？</p>
					</div>
					<div slot="footer">
						<Button type="error" size="large" long :loading="modal_loading" @click="updteState()">确定</Button>
					</div>
				</Modal>
				
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
		
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading:false,
				total:100,
				columns12: [{
						title: 'id',
						key: 'id',
						width:80,
						align: 'center',
					},
					{
						title: '合同编号',
						key: 'contractCode',
						width:120,
						align: 'center',
					},
					{
						title: '加盟商名称',
						key: 'allianceName',
						width:150,
						align: 'center',
					},
					{
						title: '金额',
						key: 'money',
						width:80,
						align: 'center',
						render: (h, params) => {
						    return h("div",params.row.money/100)
						}
					},
					{
						title: '责任人',
						key: 'dutyEmpName',
						width:120,
						align: 'center',
					},
					{
						title: '录入人',
						key: 'empName',
						width:120,
						align: 'center',
					},
					{
						title: '设备安装状态',
						key: 'macContractStateName',
						width:150,
						align: 'center',
					},
					{
						title: '录入时间',
						key: 'createdTime',
						width:150,
						align: 'center',
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [
					
				],
				query:{
					page:0,
					size:10,
					kaishiTime:'',
					jieshuTime:'',
					like:'',
					alliances:[]
				},
				alliances:[],
				modal2: false,
				modal_loading: false,
				deleteId:''
			}
		},
		methods: {
			forbidden(id){
				this.deleteId=id
				this.modal2=true
			},
			updteState(){
				let _this=this
				if(this.deleteId==""){
					this.$Message.error('参数错误，请刷新页面后重试!');
				}else{
					_this.modal_loading = true;
					http.http({
					    //这里是你自己的请求方式、url和data参数
					    method: 'post',
					    url: http.url + '/fin/report/contract/update/state',
					    data: {id:_this.deleteId},
						_this: _this,
						success: function(data) {
							_this.modal2 = false;
							_this.$Message.success('修改成功！！！');
							_this.ajaxPage()
						}
					    //假设后台需要的是表单数据这里你就可以更改
					  })
					
				}
			},
			update(id) { //修改
				this.$router.push({
					name: 'jm/platform/macOrder/update',
					query:{
						id:id
					}
				})
			},
			add() {
				this.$router.push({
					name: 'jm/platform/macOrder/add'
				})
			},
			
			details(id) {
				this.$router.push({
					name: 'jm/platform/macOrder/details/list',
					query:{
						id:id
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			//查询条件
			onchangeKaishi(time){
				let _this=this
				_this.query.kaishiTime=time
			},
			onchangeJieshu(time){
				let _this=this
				_this.query.jieshuTime=time
			},
			onok(){
				let _this=this
				let ks=new Date(_this.query.kaishiTime).getTime()
				let js=new Date(_this.query.jieshuTime).getTime()
				let d=Math.floor((js-ks)/(24*3600*1000))
				console.log(d)
				if(d<=31){
					if(ks >=js){
						_this.$Message.error('开始时间必须小于结束时间!');
					}else{
				        _this.ajaxPage()
					}
					
				}else{
					
					_this.$Message.error('查询时间支持的最大跨度为31天!');
				}
			},
			onchangeSousuo1(){
				let _this=this
				_this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			},
			onsearch(){
				let _this=this
				_this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			},
			//查询条件
			ajaxPage() {
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/contract/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			ajaxPageAlliance() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/alliance/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.alliances = data.alliances.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page
	    },
		created(){
			this.ajaxPage()
			this.ajaxPageAlliance()
		}
	}
</script>
<style>
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
</style>
<style scoped="scoped" lang="less">
	
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
	.query{
		display: flex;
		justify-content: space-between;
		margin: 10px 0;
		.checkbox{
			display: flex;
			.tj{
				display: flex;
				align-items: center;
			}
			.time{
				display: flex;
				.time-xz{
					display: flex;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/macOrder/list.vue